import React from 'react';

const CircleLi = ({className}) => (
  <svg className={className} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" fill="#E8EEF4"/>
  </svg>

);

export default CircleLi;
